import Tippy from 'tippy.js';
// import svgArrow from './assets/popup-arrow.svg';
// import svgArrow from '@img/popup-arrow.svg';

const popupElementReference = document.querySelector('.tippy-reference-content');
const targetElement = '#popup-trigger-button';
const targetElementButton = document.getElementById('popup-trigger-button');

const svgMarkup = `<svg width="38px" height="19px" viewBox="0 0 38 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Popup-/-Robust" transform="translate(-264.000000, -577.000000)" fill="#B31B1C">
      <path d="M264,577 L302,577 L287.449215,593.082447 C285.226003,595.53968 281.431753,595.729393 278.97452,593.506182 C278.826305,593.372083 278.684884,593.230662 278.550785,593.082447 L264,577 Z" id="Rectangle"></path>
    </g>
  </g>
</svg>
`;

const tippyProps = {
  allowHTML: true,
  animation: 'fade',
  arrow: false,
  content: '',
  inertia: true,
  interactive: true,
  interactiveBorder: 38,
  maxWidth: 350,
  placement: 'top',
  trigger: 'click',
  // https://atomiks.github.io/tippyjs/v6/all-props/#appendto
  appendTo: 'parent',
  onShow(instance) {
    // targetElementButton.setAttribute('data-button-active', 'true');
  },
  onHide(instance) {
    // targetElementButton.setAttribute('data-button-active', 'false');
  },
  onShown(instance) {
    instance.setContent(popupElementReference);
    instance.setProps({
      arrow: svgMarkup
    });
    const close_button = instance.popper.querySelector('#popover-close');
    setTimeout(() => {
      close_button.removeAttribute('aria-hidden');
      close_button.removeAttribute('tabindex');
    }, 1000);
    close_button.addEventListener('click', () => {
      instance.hide();
    });
  }

};

Tippy( targetElement, tippyProps );
